module.exports = __webpack_public_path__ + "img/icon-startups-white.69a1dd79.svg";